import React, { memo } from 'react'
import { Grid } from '@mui/material'

import { CAMPAIGN_PROFILE_DISPATCH } from '../../store/reducers/campaign/campaign'
import CustomDialog from '../shared/CustomDialog/CustomDialog'
import CustomDatePicker from '../shared/inputs/CustomDatePicker'
import {
  transWithArgs,
  validNaturalNumberRule
} from '../../util/validation.helpers'
import Input from '../shared/inputs/Input'
import { QB_ERROR_TEXT } from '../../constants/messages'
import {
  DEFAULT_INPUT_MAX_LENGTH,
  CAMPAIGN_NAME_MAX_LENGTH
} from '../../constants/validation'

import { formatTicks } from '../../util/string.helpers'
import { calculatePointValue } from '../../util/token.helpers'
import { DATE_TIME_PICKER_FORMAT } from '../../constants/date'
import { getTodaysDate } from '../../util/date.helpers'
import { Trans } from 'react-i18next'
import Dropdown from '../shared/inputs/Dropdown'
import {
  buildCampaignTypeOptions,
  CAMPAIGN_TYPE_OPTIONS,
  UNIQUE_CAMPAIGN_MAX_SUPPLY
} from '../../util/campaign.helpers'

const CreateCampaignForm = ({
  campaignProfile: {
    error,
    isProcessing,
    nameTemp,
    valueTemp,
    supplyTemp,
    typeTemp,
    validUntilTemp
  },
  tokenProfile: { symbol, onramp },
  dispatchAction,
  onClose,
  onSubmit,
  title,
  submitLabel,
  t
}) => {
  return (
    <CustomDialog
      open
      submitProps={{
        label: submitLabel,
        disabled: isProcessing
      }}
      onSubmit={onSubmit}
      onClose={onClose}
      paperProps={{
        maxWidth: '650px'
      }}
      isForm
      title={title}
      description={
        <Trans i18nKey='campaign.create-campaign-desc' values={{ symbol }} />
      }
      body={
        <>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Input
                id={CAMPAIGN_PROFILE_DISPATCH.NAME_TEMP}
                label={t('campaign.description-for-admins')}
                value={nameTemp}
                errorMessage={transWithArgs(
                  t,
                  error[CAMPAIGN_PROFILE_DISPATCH.NAME_TEMP]
                )}
                onChange={(value) =>
                  dispatchAction(CAMPAIGN_PROFILE_DISPATCH.NAME_TEMP, value)
                }
                bottomLabel={t(QB_ERROR_TEXT.CHARACTERS_MAX, {
                  max: formatTicks(CAMPAIGN_NAME_MAX_LENGTH)
                })}
                inputProps={{ maxLength: CAMPAIGN_NAME_MAX_LENGTH }}
                size='small'
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item md={4} xs={12}>
              <Input
                id={CAMPAIGN_PROFILE_DISPATCH.VALUE_TEMP}
                label={t('campaign.reward-in', { symbol })}
                value={valueTemp}
                errorMessage={transWithArgs(
                  t,
                  error[CAMPAIGN_PROFILE_DISPATCH.VALUE_TEMP]
                )}
                onChange={(value) =>
                  dispatchAction(CAMPAIGN_PROFILE_DISPATCH.VALUE_TEMP, value)
                }
                bottomLabel={t('common.equivalent-to', {
                  value: formatTicks(calculatePointValue(valueTemp, onramp))
                })}
                inputProps={{ maxLength: DEFAULT_INPUT_MAX_LENGTH }}
                size='small'
                validate={[validNaturalNumberRule]}
                placeholder={t('common.enter-number')}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Dropdown
                id={CAMPAIGN_PROFILE_DISPATCH.TYPE_TEMP}
                label={t('common.type')}
                value={typeTemp}
                options={buildCampaignTypeOptions(t)}
                errorMessage={transWithArgs(
                  t,
                  error[CAMPAIGN_PROFILE_DISPATCH.TYPE_TEMP]
                )}
                onChange={({ target }) =>
                  dispatchAction(
                    CAMPAIGN_PROFILE_DISPATCH.TYPE_TEMP,
                    target.value
                  )
                }
                size='small'
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Input
                id={CAMPAIGN_PROFILE_DISPATCH.SUPPLY_TEMP}
                label={t('nft.supply')}
                value={supplyTemp}
                errorMessage={transWithArgs(
                  t,
                  error[CAMPAIGN_PROFILE_DISPATCH.SUPPLY_TEMP]
                )}
                onChange={(value) =>
                  dispatchAction(CAMPAIGN_PROFILE_DISPATCH.SUPPLY_TEMP, value)
                }
                placeholder={t('common.enter-number')}
                size='small'
                validate={[validNaturalNumberRule]}
                bottomLabel={
                  typeTemp === CAMPAIGN_TYPE_OPTIONS.UNIQUE &&
                  t('campaign.max-supply', {
                    value: formatTicks(UNIQUE_CAMPAIGN_MAX_SUPPLY)
                  })
                }
                inputProps={{ maxLength: DEFAULT_INPUT_MAX_LENGTH }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <CustomDatePicker
                id={CAMPAIGN_PROFILE_DISPATCH.VALID_UNTIL_TEMP}
                label={t('campaign.active-until')}
                errorMessage={transWithArgs(
                  t,
                  error[CAMPAIGN_PROFILE_DISPATCH.VALID_UNTIL_TEMP]
                )}
                onChange={(value) => {
                  dispatchAction(
                    CAMPAIGN_PROFILE_DISPATCH.VALID_UNTIL_TEMP,
                    value
                  )
                }}
                value={validUntilTemp}
                minDateTime={getTodaysDate()}
                size='small'
                enableTime
                inputFormat={DATE_TIME_PICKER_FORMAT}
                inputProps={{
                  placeholder: '',
                  autoComplete: 'off'
                }}
              />
            </Grid>
          </Grid>
        </>
      }
      t={t}
    />
  )
}

export default memo(CreateCampaignForm)
